import { Component, OnInit, Input } from '@angular/core';

import { InfoModal } from './info-modal.interface';
import { InfoModalContentComponent } from './ components/info-modal-content/info-modal-content.component';
import { ModalComponent } from '@finder/shared/components/modal/modal.component';
import { ModalService } from '@finder/shared/components/modal/modal.service';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from '../button/button.component';

@Component({
    selector: 'finder-info-modal',
    templateUrl: './info-modal.component.html',
    styleUrls: ['./info-modal.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        ButtonComponent,
    ],
})
export class InfoModalComponent implements OnInit {

    @Input() data: InfoModal;

    modal: ModalComponent;

    constructor(
        private modalService: ModalService
    ) {}

    ngOnInit() {
        this.modal = this.modalService.create(
            InfoModalContentComponent,
            {
                hideOnClose: true,
                title: this.data.title,
                data: this.data.content
            }
        );
    }

    openModal() {
        this.modal.open();
    }
}
